import { useCallback, useState } from 'react';
import toast from 'react-hot-toast';

import { FormContainer } from '../../../_core/form/form-container.component';
import { ICloseableDialogProps } from '../../../_core/core.types';
import { showError } from '../../../../lib/utils';
import { useSendTransactionalMessage } from '../message.service';
import { IRequestAccessFormParams } from '../message.types';
import { RequestAccessForm } from './request-access-form.component';

export const RequestAccessContainer = ({ close }: Partial<ICloseableDialogProps>) => {
  const [submitError, setSubmitError] = useState<string | null>(null);

  const { sendTransactionalMessage } = useSendTransactionalMessage();

  const handleSubmit = useCallback(
    async ({ email, name }: IRequestAccessFormParams) => {
      try {
        const success = await sendTransactionalMessage({
          messageId: 'custom_message',
          to: 'Contact@RequestIQ.com',
          trigger: {
            subject: `${name} requested access to RequestIQ`,
            recipient: 'Request IQ Team',
            message: `${name} (${email}) has requested access to RequestIQ, please share an access code with them.<br /><br />Tell them to use <b>TRYRIQ</b> or share the following link: https://requestiq.com?signup=TRYRIQ.`
          }
        });

        if (success) {
          toast.success('Requested access');
          close?.();
        } else setSubmitError('Failed to request access');
      } catch (err) {
        showError('Failed requesting access', err as Error);
        setSubmitError('Failed requesting access');
      }
    },
    [close, sendTransactionalMessage]
  );

  return (
    <FormContainer error={submitError} setError={setSubmitError} title="Request Access">
      <RequestAccessForm onSubmit={handleSubmit} onBack={close} />
    </FormContainer>
  );
};
